"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEvents = exports.GameEventKind = void 0;
const Snapshot_1 = require("../../model/Snapshot");
var GameEventKind;
(function (GameEventKind) {
    GameEventKind["Created"] = "poker:game:created";
    GameEventKind["Start"] = "poker:game:start";
    GameEventKind["Pause"] = "poker:game:pause";
    GameEventKind["End"] = "poker:game:end";
    GameEventKind["SnapshotForPlayer"] = "api:user:game:snapshot:for:player";
})(GameEventKind = exports.GameEventKind || (exports.GameEventKind = {}));
class GameEvents {
    static created(game) {
        return GameEvents.createEvent(GameEventKind.Created, game);
    }
    static started(game) {
        return GameEvents.createEvent(GameEventKind.Start, game);
    }
    static paused(game) {
        return GameEvents.createEvent(GameEventKind.Pause, game);
    }
    static ended(game) {
        return GameEvents.createEvent(GameEventKind.End, game);
    }
    static createEvent(eventKind, game) {
        return {
            name: eventKind,
            timestamp: Date.now(),
            kind: eventKind,
            snapshot: Snapshot_1.GameSnapshotter.forGame(game),
        };
    }
}
exports.GameEvents = GameEvents;
//# sourceMappingURL=GameEvent.js.map